import React, { ReactElement } from "react";
import { ensure } from "sprint-common-web";

import { LanguageDetailsInfo } from "../../../../common/components/details-info/LanguageDetailsInfo";
import { VideoDetailsInfo } from "../../../../common/components/details-info/VideoDetailsInfo";
import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { RecordType } from "../../../../common/types/RecordType";
import { ConformingAssetListingItem } from "./ConformingAssetItem";

export const renderConformingAssetDetails = (item?: ConformingAssetListingItem): ReactElement => {
    ensure(item);

    if (item.recordType === RecordType.Video) {
        return (
            <VideoDetailsInfo
                key="video-details"
                aspectRatio={item.details.aspectRatio}
                subtitle={item.details.subtitle}
            />
        );
    }

    if (item.recordType === RecordType.Subtitle) {
        return (
            <LanguageDetailsInfo
                key="subtitle-details"
                language={item.details.subtitle}
                subtitleType={DynamicSubtitleType[item.details.subtitleType]}
            />
        );
    }

    if (item.recordType === RecordType.Audio) {
        return <LanguageDetailsInfo key="soundtrack-details" language={item.details.soundtrack} />;
    }

    return <></>;
};
